module.exports = __webpack_public_path__ + "static/img/bg2.ebb2c48.png";


//////////////////
// WEBPACK FOOTER
// ./static/llog/bg2.png
// module id = dT2i
// module chunks = 0